<template>
  <div class="scholarFail">
    <div class="scholarFail_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
      <div class="my">{{ $route.query.title }}</div>
    </div>
    <div class="scholarFail_bottom">
      <img src="../../../../assets/mylogin/notPass2x.png" alt="" />
      <p class="text">审核未通过</p>
      <p class="fail" v-html="cause"></p>
    </div>
    <div class="scholarFail_button">
      <van-button type="info" round class="homepage" @click="homepage"
        >重新认证</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "scholarFail",
  data() {
    return {
      cause: "",
    };
  },
  created() {
    this.status = this.$route.query.status;
    this.authStatus();
  },
  methods: {
    to() {
      window.history.go(-1);
    },
    // 查询认证状态
    async authStatus() {
      const { data = { cause: "" } } = await this.$apis.userServe.authStatus(2);
      this.cause = data.cause;
    },
    // 返回首页
    homepage() {
      this.$router.push("authentication");
    },
  },
};
</script>

<style lang="scss" scoped>
.scholarFail {
  width: 100vw;
  min-height: 100vh;
  background: #fff;

  .scholarFail_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;

    .my {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
    }
  }

  .scholarFail_bottom {
    width: 100%;
    margin-top: 139px;
    text-align: center;

    img {
      width: 83px;
      height: 83px;
    }

    .text {
      width: 84%;
      margin: 10px auto;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }

    .fail {
      width: 84%;
      margin: 10px auto;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff3d3d;
      word-break: break-all;
    }
  }

  .scholarFail_button {
    width: 84%;
    height: 40px;
    margin: 40px auto;
    // justify-content: center;
    justify-content: space-between;

    .homepage {
      width: 100%;
      height: 40px;
    }
  }
}
</style>
